import { motion } from "framer-motion";
import aboutImg from "./assets/about1.png";

const HeroSection = () => {
  return (
    <section className="snap-section bg-white py-12 overflow-hidden">
      <div className="max-w-[1200px] mx-auto px-6">

        <div className="flex flex-col lg:flex-row items-center gap-16">

          <motion.div
            className="flex-1 text-center lg:text-left"
            initial={{ x: -80, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-[#FF7A00] font-semibold mb-4 uppercase tracking-wide">
              About Winglo
            </p>

            <h1 className="text-3xl md:text-4xl font-bold text-[#1F2937] mb-6 leading-tight">
              Empowering Healthcare with{" "}
              <span className="text-[#FF7A00]">Intelligent Solutions</span>
            </h1>

            <p className="text-gray-600 leading-relaxed mb-6">
              Founded in 2017, Winglo is a cloud-based Healthcare IT product company
              specializing in Laboratory Information Management Systems (LIMS).
              Built by domain experts with decades of experience, our platform helps
              laboratories improve efficiency, accuracy, and operational excellence
              through scalable and intelligent technology.
            </p>

            <p className="text-gray-600 leading relaxed">
              Winglo has AI enabled PMS and HIS in its 2026 roadmap and would be a seamless integrated product and a one-stop shop for any Healthcare Service Provider with all necessary product on one platform.
            </p>
          </motion.div>

          <motion.div
            className="flex-1 flex justify-center"
            initial={{ x: 80, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <img
              src={aboutImg}
              alt="About Winglo"
              className="w-full max-w-[450px] h-[420px] object-contain rounded-3xl shadow-xl"
            />
          </motion.div>

        </div>

      </div>
    </section>
  );
};

export default HeroSection;